import { IPoi } from '../../../domain/models/IPoiItem';
import ShopIcon from '../../../../../assets/icons/poi/shop.svg';
import DineIcon from '../../../../../assets/icons/poi/dine.svg';
import AmenityIcon from '../../../../../assets/icons/poi/amenity.svg';

export const getPoiCardIcon = (poiItem: IPoi): React.ReactNode => {
	switch (poiItem.type) {
		case 'Shop':
			return <ShopIcon aria-label="Shop" aria-hidden="true" />;
		case 'Dining':
			return <DineIcon aria-label="Dining" aria-hidden="true" />;
		case 'Amenity':
			return <AmenityIcon aria-label="Amenity" aria-hidden="true" />;
		default:
			return undefined;
	}
};
